import { EVENT_NAME_BDK_CHALLENGE_2026 } from '../../common/challengeConstants';
import config from '../../config';
import {
  ChallengeImageData,
  ImagePreSignedUrlAndPath,
} from '../../model/ChallengeImageUpload.model';
import AxiosHealthWellness from '../healthWellness';

export const getChallengeImages = async ({ eventId, userId, scoreId }) => {
  try {
    let URL = `${config.API_URL}/hnw/challenge-external/challenge-image?eventId=${eventId}&userId=${userId}`;
    if (scoreId) {
      URL = `${URL}&scoreId=${scoreId}`;
    }
    const response = await AxiosHealthWellness.get(URL);
    return response?.data?.length
      ? response?.data?.map((imageObj) => new ChallengeImageData(imageObj))
      : [];
  } catch (error) {
    throw error;
  }
};

export const getPreSignedUrl = async ({
  eventId,
  partyId,
  fileName,
  contentType,
}) => {
  try {
    const URL = `${config.API_URL}/hnw/challenge-external/challenge-image/pre-signed-url?eventId=${eventId}&partyId=${partyId}&fileName=${fileName}&contentType=${contentType}`;
    const response = await AxiosHealthWellness.get(URL);
    return new ImagePreSignedUrlAndPath(response?.data);
  } catch (error) {
    throw error;
  }
};

export const putPreSignedUrl = async ({ preSignedUrl, contentType, file }) => {
  try {
    const myHeaders = new Headers();
    myHeaders.append('Content-Type', contentType);
    const requestOptions = {
      method: 'PUT',
      redirect: 'follow',
      headers: myHeaders,
      body: file,
    };
    const response = await fetch(preSignedUrl, requestOptions);
    const result = response.text();
    return result;
  } catch (error) {
    throw error;
  }
};

export const putConfirmUpload = async ({
  eventId,
  uploadId,
  path,
  approveStatus,
  fileDesc,
  uploadDate,
  createdAt,
}) => {
  try {
    const data = `eventId=${eventId}&uploadId=${uploadId}&path=${path}&approveStatus=${approveStatus}&fileDesc=${fileDesc}&uploadDate=${uploadDate}&createdAt=${createdAt}`;
    const configObj = {
      maxBodyLength: Infinity,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    const response = await AxiosHealthWellness.put(
      `${config.API_URL}/hnw/challenge-external/challenge-image/confirm-upload`,
      data,
      configObj,
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const postChallenge30DaysUpload = async ({
  file,
}) => {
  try {
    const formData = new FormData();
    formData.append('imageFile', file);
    const response = await AxiosHealthWellness.post(`${process.env.REACT_APP_API_URL}/hnw/challenge/upload?eventType=${EVENT_NAME_BDK_CHALLENGE_2026}`,
      formData,
    );
    return response?.data?.data;
  } catch (err) {
    throw err;
  }
};

export const getChallenge30DaysImages = async (payload) => {
  try {
    const response = await AxiosHealthWellness.get(`${process.env.REACT_APP_API_URL}/hnw/challenge/customer-data`,
      {
        params: payload,
      },
    );
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const postChallenge30DaysImagesSubmit = async (payload) => {
  try {
    const response = await AxiosHealthWellness.post(`${process.env.REACT_APP_API_URL}/hnw/challenge/customer-data`,
      payload,
    );
    return response?.data?.data;
  } catch (err) {
    throw err;
  }
};
